import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { config } from '@/utils/config';

export function initFaro(): void {
  if (!config.FARO_ENABLED || !config.FARO_COLLECTOR_URL) return;

  try {
    initializeFaro({
      url: config.FARO_COLLECTOR_URL,
      apiKey: config.FARO_API_KEY || undefined,
      app: {
        name: config.FARO_APP_NAME || 'extract-ui',
        version: config.APP_VERSION || undefined,
        environment: config.ENVIRONMENT,
      },
      instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()],
    });
  } catch (err) {
    console.error('[faro] initialisation failed', err);
  }
}
